<template>
  <div class="nav-container">
    <div
      class="nav-container__step"
      v-for="(option, index) in stepOptions"
      :key="option.id"
    >
      <div class="qn-header-container">
        <div class="d-flex align-items-center">
          <span
            class="fa-stack qn-header-container__icon-container cursor-pointer"
          >
            <em
              class="fas fa-circle fa-stack-2x"
              :class="{
                'qn-header-container--active': option.active,
                'qn-header-container--completed': option.completed,
                'qn-header-container--disabled':
                  !option.active && !option.completed,
              }"
            />
            <span
              class="fa-stack-1x"
              :class="{
                'text-white': option.active,
                'color-gray-19': !option.active && !option.completed,
              }"
            >
              <em v-if="option.completed" class="fas fa-check text-white" />
              <b v-else>{{ index + 1 }}</b>
            </span>
          </span>
          <span
            class="font-14 font-weight-bold qn-header-container__title pr-4 border-bottom"
            :class="{
              'qn-header-container__title--active': option.active,
              'qn-header-container__title--completed': option.completed,
              'qn-header-container__title--disabled':
                !option.active && !option.completed,
            }"
          >
            <span>{{ option.title }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationHeader',
  props: {
    currentStepId: {
      type: Number,
      default: () => 0,
    },
    steps: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    stepOptions() {
      let active = this.steps.find((x) => x.id == this.currentStepId);
      active = active ?? this?.steps[0];

      return this.steps.map((step, index) => ({
        id: step.id,
        title: step.title,
        active: step.id == active?.id,
        completed: index < this.steps.indexOf(active),
      }));
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/bootstrap/_colors.scss';

.nav-container {
  display: flex;
}
.qn-header-container {
  width: 100%;

  &--active {
    color: map-get($colors, 'primary-1');
  }

  &--completed {
    color: map-get($colors, 'primary-1');
  }

  &--disabled {
    color: map-get($colors, 'gray-17');
  }

  &__icon-container {
    cursor: pointer;
    margin-right: 8px;
  }

  &__title {
    flex: 1;
    &--active {
      color: map-get($colors, 'black-1');
    }
    &--completed {
      color: map-get($colors, 'gray-18');
    }
    &--disabled {
      color: map-get($colors, 'gray-19');
    }
  }
}

@media (max-width: 991px) {
  .nav-container {
    flex-direction: column;
    &__step {
      margin-bottom: 10px;
    }
  }
}
</style>
